import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/sales`, {params})
    },
    getGiftProduct() {
        return Vue.axios.get(`/gift-product`)
    },
    updateGiftProduct(params) {
        return Vue.axios.post(`/gift-product`, params)
    },
    getUkraineGiftProduct() {
        return Vue.axios.get(`/gift-product/ukraine`)
    },
    updateUkraineGiftProduct(params) {
        return Vue.axios.post(`/gift-product/ukraine`, params)
    },
    get(id) {
        return Vue.axios.get(`/sales/id/${id}`)
    },
    create(params) {
        return Vue.axios.post(`/sales/create`, params)
    },
    update(id, params) {
        return Vue.axios.post(`/sales/update/${id}`, params)
    },
    remove(id){
        return Vue.axios.get(`/sales/remove/${id}`)
    },
    updateProducts(id, data) {
        return Vue.axios.post(`/sales/update/${id}/products`, data)
    },
    listCashback(params) {
        return Vue.axios.get(`/cashback`, {params})
    },
    createCashback(params) {
        return Vue.axios.post(`/cashback/create`, params)
    },
    updateCashback(id, params) {
        return Vue.axios.post(`/cashback/update/${id}`, params)
    },
    listGift(params) {
        return Vue.axios.get(`/gifts`, {params})
    },
    createGift(params) {
        return Vue.axios.post(`/gifts/create`, params)
    },
    removeGift(id) {
        return Vue.axios.post(`/gifts/remove/${id}`)
    },
    updateGift(id, params) {
        return Vue.axios.post(`/gifts/update/${id}`, params)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
